module.exports = __webpack_public_path__ + "static/img/w_23_m.79e8e39e.png";